import LoginButtonComponent from '@/frontend/components/LoginButtonComponent';
import RegistrationButtonComponent from '@/frontend/components/RegistrationButtonComponent.vue';
import LogoIcon from '@/frontend/components/icons/LogoIcon';
import PhoneIcon from '@/frontend/components/icons/PhoneIcon.vue';
import { mapGetters } from 'vuex';
export default {
  name: "MainFooter",
  components: {
    LoginButtonComponent,
    RegistrationButtonComponent,
    LogoIcon,
    PhoneIcon
  },

  data() {
    return {
      year: new Date().getFullYear(),
      cookiePermissions: this.$cookies.get('cookie_permissions')
    };
  },

  computed: mapGetters(['can']),
  methods: {
    cookieConfirm() {
      this.$cookies.set('cookie_permissions', true, '30d');
      location.reload();
    }

  }
};